import React from 'react';
import { randUuid } from 'utils/functions';

const escapeRegExp = (str = '') => str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');

const SearchHighlight = ({ children, search }) => {
    const RegexSearchString = search
        .replace(/\s+/g, ' ')
        .trim()
        .split(' ')
        .map((word) => escapeRegExp(word))
        .join('|');
    const regex = new RegExp(`(${RegexSearchString})`, 'i');
    const items = children && children.split(regex);
    return (
        <span className={'search-highlight-text'}>
            {items && search && search.trim() !== ''
                ? items.map((item) =>
                      regex.test(item) ? (
                          <mark className="search-highlight-mark" key={`item ${randUuid()}`}>
                              {item}
                          </mark>
                      ) : (
                          item
                      ),
                  )
                : children}
        </span>
    );
};

export default SearchHighlight;
